import React, {useEffect, useState} from 'react';
import {SvgIcon} from '@montana/shared/svg-icon';
import {useTranslations} from '@montana/containers/translations';
import {IARDesktopProps} from '@montana/shared/ar-desktop/ar-desktop';
import {OnlyLargeDesktop} from '@montana/shared/responsive';
import {encodeReservedChars} from '@montana/helpers/google-maps.helper';

export const ARDesktop: React.FC<IARDesktopProps> = React.memo((props: IARDesktopProps): JSX.Element => {
    const {cylindoSku, dimensions} = props;
    const translate = useTranslations();
    const [arQRUrl, setArQRUrl] = useState<string>('');

    useEffect(() => {
        const featureUrl: string[] = [];
        dimensions?.forEach(dimension => {
            featureUrl.push(`feature=${dimension.cylindoFeatureParameters?.replace('feature=', '')}`)
        });
        setArQRUrl(`https://content.cylindo.com/api/v2/4953/products/${cylindoSku}/ARQR/${cylindoSku}?${featureUrl.join('&')}&redirect_url=${encodeReservedChars(document.location.href)}`);
    }, [dimensions])

    return (
        <OnlyLargeDesktop>
            <div className="ar-desktop">
                <div className="ar-desktop__content">
                    <button type="button" className="ar-desktop__button">
                        <span>{translate(t => t.productPage.arLinkText, '[View product live]')}</span><SvgIcon
                            iconName="ar"/>
                        <div className="ar-desktop__overlay-container">
                            <div className="ar-desktop__overlay">
                                <h4>{translate(t => t.productPage.arDesktopOverlayTitle, '[View this product in your surroundings]')}</h4>
                                <p>{translate(t => t.productPage.arDesktopOverlayDesc, '[Use your mobile phone or tablet to scan the QR code. Use either your device native camera app or a QR scanner app of your own chose.]')}</p>
                                <img className="ar-desktop__qr-code"
                                    src={arQRUrl}/>
                            </div>
                        </div>
                    </button>
                </div>
            </div>
        </OnlyLargeDesktop>
    )
})
